<mat-form-field appearance="outline">
  <mat-label>{{ label ?? name }}</mat-label>
  <input matInput type="text" [formControlName]="name" [placeholder]="placeholder ?? label ?? name" />
  @if (description) {
    <mat-hint class="custom-hint">
      <mat-icon>info</mat-icon>
      {{ description }}
    </mat-hint>
  }
</mat-form-field>